module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d6f7dab02cab1c0bb35a8ea7e1a7320e.png";